import * as React from "react";
const SVGComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 692 593"
    fill="none"
    {...props}
  >
    <path
      d="M592.142 395.417C646.745 395.417 690.996 439.445 690.996 493.756C690.996 548.075 646.745 592.096 592.142 592.096C537.576 592.096 493.289 548.075 493.289 493.756C493.289 439.445 537.576 395.417 592.142 395.417Z"
      stroke="white"
      strokeWidth={1.5}
    />
    <path
      d="M307.876 372.827L32.7721 152.061C-3.92728 122.608 -9.67325 69.1178 19.9272 32.61C49.5351 -3.89853 103.282 -9.62204 140.011 19.8318L415.085 240.597C451.814 270.051 457.56 323.548 427.952 360.056C398.351 396.565 344.575 402.281 307.876 372.827Z"
      stroke="white"
      strokeWidth={1.5}
    />
  </svg>
);
export default SVGComponent;
